import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { QuizQuestion, QuizQuestionDraft } from '@domain/models/streaming.model';
import { QuizQuestionRepository } from '@domain/repositories/streaming.repository';

import type { ApiPagedResponse } from '@data/dto/api.dto';
import type { QuizQuestionDto } from '@data/dto/streaming.dto';
import { mapPagedQuizQuestions, mapQuizQuestion } from '@data/mappers/streaming.mapper';

@Injectable()
export class QuizQuestionApiRepository extends QuizQuestionRepository {
  private readonly http = inject(HttpClient);
  private readonly path = 'api/Questions';

  list(query: PageQuery): Observable<PagedResult<QuizQuestion>> {
    let params = new HttpParams({
      fromObject: {
        page: String(query.page),
        limit: String(query.pageSize),
      },
    });
    if (query.search?.trim()) {
      params = params.set('text', query.search.trim());
    }
    return this.http
      .get<ApiPagedResponse<QuizQuestionDto>>(this.path, { params })
      .pipe(map(mapPagedQuizQuestions));
  }

  getById(questionId: number): Observable<QuizQuestion> {
    return this.http.get<QuizQuestionDto>(`${this.path}/${questionId}`).pipe(map(mapQuizQuestion));
  }

  create(draft: QuizQuestionDraft): Observable<{ questionId: number }> {
    return this.http.post<{ questionId: number }>(this.path, draft);
  }

  update(questionId: number, draft: QuizQuestionDraft): Observable<void> {
    return this.http.put<void>(`${this.path}/${questionId}`, draft);
  }

  delete(questionId: number): Observable<void> {
    return this.http.delete<void>(`${this.path}/${questionId}`);
  }
}
